import { render } from "./B2bFilterButtonAuditoriaDocumentos.vue?vue&type=template&id=70602d82&scoped=true&lang=pug"
import script from "./B2bFilterButtonAuditoriaDocumentos.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonAuditoriaDocumentos.vue?vue&type=script&lang=js"

import "./B2bFilterButtonAuditoriaDocumentos.vue?vue&type=style&index=0&id=70602d82&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70602d82"]])

export default __exports__